import { React, useCallback, useState } from "react";
import "react-phone-number-input/style.css";
import Navauth from "../partials/navauth";
import { NavLink } from "react-router-dom";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { SignupSchema } from "../../validation/schema";
import { formatAPIErrorMessages } from "../../lib/utils";
import { useSignUp } from "../../api/mutations";
import { Button } from "../../lib";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../lib";
import arrowPng from "../../images/arrow.png";
import logo from "../../images/logo.png";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";

const initialValues = {
  countryDialingCode: "+234",
  phoneNumber: "",
  email: "",
  username: "",
  password: "",
  onboardingQuestionAnswer: "",
  country: "ZA",
};

function Signup() {
  const [error, setError] = useState("");
  const { mutateAsync, isPending, isSuccess } = useSignUp();
  const navigate = useNavigate();
  const toast = useToast();
  const [, setAuthUser] = useRecoilState(auth_user);

  const handleSubmit = useCallback(async (values) => {
    try {
      const form = new FormData();
      for (let element in values) {
        form.append(element, values[element]);
      }
      form.append("profilePicture", arrowPng);
      const response = await mutateAsync(values);
      setAuthUser(response?.user);
      toast({
        type: "success",
        message: "Onboarding successful",
      });
      navigate("/signup/otp");
    } catch (error) {
      toast({
        type: "error",
        message: error?.response?.data?.message ?? "An Error occured",
      });
    }
  }, []);

  return (
    <div>
      {/* TODO: This success variable allows you to transition when you get your tokens */}
      {isSuccess ? <Navauth /> : <></>}
      <div className="container w-full min-h-screen flex justify-center items-center relative ">
        <div className="absolute top-0 left-0 mt-6">
          <NavLink to="/">
            <img
              src={logo}
              className="img-fluid ml-4 lg:scale-125 logo "
              alt="logo"
            />
          </NavLink>
        </div>
        <div className="row lg:px-[160px] lg:my-[170px]">
          <div className="col-lg-12">
            <div className="flex p-4 mt-20 md:mt-0 flex-col md:flex-row justify-between items-start md:items-center">
              <h3 className="header-signup lg:text-[30px] text-[22px] whitespace-nowrap md:text-[40px]">
                Let’s Create your Account
              </h3>{" "}
              <span className="terms">Terms of Service</span>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={SignupSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="row  padding-form ">
                  {error ? <p className="form-error">{error}</p> : <></>}
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      as="select"
                      name="countryDialingCode"
                    >
                      <option value="+234">+234 - Nigeria</option>
                      <option value="+27">+27 - South Africa</option>
                    </Field>
                    <ErrorMessage
                      className="form-field-error"
                      name="countryDialingCode"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="text"
                      name="phoneNumber"
                      placeholder="Enter Mobile number"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="phoneNumber"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="email"
                      name="email"
                      placeholder="Email e.g john@example.com"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="email"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="text"
                      name="username"
                      placeholder="Create a Unique Username 😁"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="username"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="password"
                      name="password"
                      placeholder="Enter Password"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="password"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      className="input-z"
                      type="password"
                      name="confirmPassword"
                      placeholder="Confirm Password"
                    />
                    <ErrorMessage
                      className="form-field-error"
                      name="confirmPassword"
                      component="div"
                    />
                  </div>
                  <div className="col-md-6 col-12">
                    <Field
                      as="select"
                      className="input-z"
                      name="onboardingQuestionAnswer"
                    >
                      <option disabled selected>
                        What would you like to use Cuppycode for?
                      </option>
                      <option value="COPY_BET_CODES">
                        Copy Bet codes and win
                      </option>
                      <option value="SELL_BET_CODES">
                        Sell Bet codes / Premium package
                      </option>
                      <option value="ALL_OF_THE_ABOVE">All of the Above</option>
                    </Field>
                    <ErrorMessage
                      className="form-field-error"
                      name="onboardingQuestionAnswer"
                      component="div"
                    />
                  </div>

                  <div className="flex lg:justify-start justify-center mx-auto">
                    <Button loading={isPending} onClick={handleSubmit}>
                      Create Account
                    </Button>
                  </div>

                  <div className="col-md-6 col-12">
                    <p className="account-text">
                      Already have an Account?{" "}
                      <span>
                        {" "}
                        <NavLink to="/login" className="login">
                          {" "}
                          Login{" "}
                        </NavLink>
                      </span>
                    </p>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
